import { useEffect, useState } from 'react';

import TrafficHelpers, { TrackingValues } from '../helpers/TrafficHelpers';

export const useTrackingValues = () => {
  const [trackingValues, setTrackingValues] = useState<TrackingValues>();

  useEffect(() => {
    const getValues = async () => {
      const values = await TrafficHelpers.getTrackingValues();
      setTrackingValues(values);
    };

    getValues();
  }, []);

  return trackingValues;
};
